<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="paddi_driver">
                            <h4>Trip Location</h4>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City Name</label>
                                    <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="transportTrip.cityId" v-on:change="getCityId($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dumpYardId)">
                                    <label>Dump Yard</label>
                                    <select v-model="transportTrip.dumpYardId" name="dumpYardId" required class="form-control">
                                        <option value="" disabled>Select Dumpyard</option>
                                        <option v-for="(item, index) in transport_Point" :key="index" :value="item.id">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="dumpYardId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            dumpyard is a required field
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.segregationId)">
                                    <label>Segegration Plant</label>
                                    <select v-model="transportTrip.segregationId" required name="segregationId" class="form-control">
                                        <option value="" disabled>Select Segregation Plant</option>
                                        <option v-for="(item, index) in segregationPlant_DumpYard" :key="index" :value="item.id">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="segregationId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Segregation Plant is a required field
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="paddi_driver">
                            <h4>Vehicle & Driver</h4>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                                    <label>Driver</label>
                                    <select required v-model="transportTrip.driverId" name="driverId" class="form-control">
                                        <option value="" disabled>Select Driver</option>
                                        <option v-for="(item, index) in driver_name" :key="index" :value="item.id" :selected="
                          item &&
                            transportTrip.driverId &&
                            item.id === transportTrip.driverId
                        ">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="driverId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Driver is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                                    <label>Vehicle</label>
                                    <select required v-model="transportTrip.vehicleId" name="vehicleId" class="form-control">
                                        <option value="" disabled>Select Vehicle</option>
                                        <option v-for="(item, index) in vehicle_name" :key="index" :value="item.id" :selected="
                          item &&
                            transportTrip.vehicleId &&
                            item.id === transportTrip.vehicleId
                        ">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Vehicle is a required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div clss="paddi_driver">
                            <h4 style="padding-left: 15px;">Schedule</h4>
                            <div class="col-sm-4">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleTime)">
                                    <label>Schedule Time</label>
                                    <datetime required id="scheduleTime" type="datetime" v-model="transportTrip.scheduleTime" lang="en" name="scheduleTime" input-class="form-control" @input="selectDateEnable($event)" :min-datetime="new Date().toISOString()" class="theme-wm" placeholder="Select Time">
                                    </datetime>
                                    <field-messages name="scheduleTime" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Start date is a required field</div>
                                    </field-messages>
                                </validate>
                                <!-- <a
                    class="fa fa-calendar"
                    aria-hidden="true"
                    role="button"
                  ></a> -->
                            </div>
                            </div>
                        </div>
                    </vue-form>
                    <!-- <div class="col-sm-12 text-right">
              <a v-if="$route.params && !$route.params._id">
                <router-link :to="{ name: 'transportPointTrip' }">
                  <button class="mr-5 btn btn-default" type="button">
                    Cancel
                  </button>
                </router-link>
              </a>
              <a v-if="$route.params && $route.params._id">
                <router-link
                  :to="{
                    name: 'viewTransportPointTrip',
                    params: { _id: $route.params._id },
                  }"
                >
                  <button class="mr-5 btn btn-default" type="button">
                    Cancel
                  </button>
                </router-link>
              </a>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="createTransportTrip"
                :disabled="!(formstate.$dirty && formstate.$valid)"
                v-if="$route.params && !$route.params._id"
              >
                Save
              </button>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="updateTransportPointTrip"
                :disabled="!(formstate.$dirty && formstate.$valid)"
                v-if="$route.params && $route.params._id"
              >
                Update
              </button>
            </div> -->
                    <div class="col-sm-12 text-right">
                        <a v-if="$route.params && $route.params._id == '0'">
                            <router-link :to="{ name: 'transportPointTrip' }">
                                <button class="mr-5 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                        </a>
                        <a v-if="$route.params && $route.params._id != '0'">
                            <router-link :to="{
                    name: 'viewTransportPointTrip',
                    params: { _id: $route.params._id },
                  }">
                                <button class="mr-5 btn btn-default" type="button">
                                    Cancel
                                </button>
                            </router-link>
                        </a>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createTransportTrip" :disabled="!(formstate.$dirty && formstate.$valid) && selectDate" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="mr-2 btn gradientbt" type="submit" @click="updateTransportPointTrip" :disabled="!(formstate.$dirty && formstate.$valid) && selectDate" v-if="$route.params && $route.params._id !='0'">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import {
    formService,
    eventBus,
    transportPointTripService,
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

export default {
    name: "createTransportPointTrip",
    data() {
        return {
            isCityDisable: false,
            driver_name: {},
            vehicle_name: {},
            cities: {},
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            trip: {},
            formstate: {},
            transport_Point: {},
            segregationPlant_DumpYard: {},
            transportTrip: {
                cdId: [],
                cityId: "",
                dumpYardId: "",
                segregationId: "",
                driverId: "",
                vehicleId: "",
                scheduleTime: "scheduleTime",
            },
            citys: {},
            segregations: {},
            tripStatus: "upcoming",
            selectDate: true,
        };
    },

    mounted: function () {
        this.getCityList();
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        selectDateEnable(value) {
            if (value.length > 0) {
                this.selectDate = false
            } else {
                this.selectDate = true
            }
        },

        createTransportTrip() {
            this.loading = true;
            let tripInfo = {};
            tripInfo.dumpYardId = this.transportTrip.dumpYardId;
            tripInfo.segregationId = this.transportTrip.segregationId;
            tripInfo.driverId = this.transportTrip.driverId;
            tripInfo.vehicleId = this.transportTrip.vehicleId;
            tripInfo.tripStatus = this.tripStatus;
            tripInfo.scheduleTime = this.transportTrip.scheduleTime;
            tripInfo.cityId = this.transportTrip.cityId;
            return transportPointTripService
                .addTransportTrip(tripInfo)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        "Segregation Plant Trip trip has been added successfully."
                    );
                    this.$router.push({
                        name: "viewTransportPointTrip",
                        params: {
                            _id: response.data._id,
                        },
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(error, "Error!");
                });
        },
        updateTransportPointTrip() {
            this.loading = true;
            let tripInfo = {};
            tripInfo.dumpYardId = this.transportTrip.dumpYardId;
            tripInfo.segregationId = this.transportTrip.segregationId;
            tripInfo.driverId = this.transportTrip.driverId;
            tripInfo.scheduleTime = this.transportTrip.scheduleTime;
            tripInfo.tripStatus = this.tripStatus;
            tripInfo.vehicleId = this.transportTrip.vehicleId;
            if(this.$route.params._id != '0'){
                tripInfo._id = this.$route.params._id;
            }
            tripInfo.cityId = this.transportTrip.cityId;
            return transportPointTripService
                .updateTransportTrip(tripInfo)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        "Segregation Plant Trip has been updated successfully."
                    );
                    this.$router.push({
                        name: "viewTransportPointTrip",
                        params: {
                            _id: response.data._id,
                        },
                    });
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error(errorMessage, "Error!");
                });
        },

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName
                }];
                this.getCityId(_id)
                this.transportTrip["cityId"] = _id;
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },

        getVehicleList(id) {
            let vehicle_nameList = [];
            return transportPointTripService
                .vehicleList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            if (element.vType === "Secondary(Large)") {
                                vehicle_nameList.push({
                                    name: element.vNumber,
                                    id: element._id,
                                });
                            }
                        }
                    });
                    vehicle_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.vehicle_name = vehicle_nameList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Vehicle.requestFunction-error:", error);
                    this.$snotify.error("Vehicle list failed", "Error!");
                });
        },

        getDriverList(id) {
            let driver_nameList = [];
            return transportPointTripService
                .driverList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            driver_nameList.push({
                                name: element.firstName + " " + element.lastName,
                                id: element._id,
                            });
                        }
                    });
                    driver_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.driver_name = driver_nameList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Driver.requestFunction-error:", error);
                    this.$snotify.error("Driver list failed", "Error!");
                });
        },

        getSegregationPlantList(cityId) {
            this.loading = true;
            const params = {};
            let segregationList = [];
            this.$segregationDataRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        if (element.isActive === true && element.cityId === cityId) {
                            segregationList.push({
                                name: element.plantName,
                                id: element._id,
                            });
                        }
                    });
                    segregationList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.segregationPlant_DumpYard = segregationList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("segregations.requestFunction-error:", error);
                    this.$snotify.error("Get segregations list failed", "Error!");
                });
        },

        getDumpYardList(cityId) {
            this.loading = true;
            const params = {};
            let dumpYardList = [];
            this.$dumpyardDataRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        if (element.isActive === true && element.cityId === cityId) {
                            dumpYardList.push({
                                name: element.dumpYardName,
                                id: element._id,
                            });
                        }
                    });
                    dumpYardList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.transport_Point = dumpYardList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Dumpyard.requestFunction-error:", error);
                    this.$snotify.error("Get dumpyard list failed", "Error!");
                });
        },

        getTrip() {
            return transportPointTripService
                .getById(this.$route.params._id)
                .then((response) => {
                    this.getCityId(response.data.cityId._id)
                    this.transportTrip["segregationId"] =
                        response.data.segregationId[0]._id;
                    this.transportTrip["dumpYardId"] = response.data.dumpYardId[0]._id;
                    this.transportTrip["cityId"] = response.data.cityId._id;
                    this.transportTrip["driverId"] = response.data.driverId[0]._id;
                    this.transportTrip["scheduleTime"] = response.data.scheduleTime;
                    this.transportTrip["tripStatus"] = response.data.tripStatus;
                    this.transportTrip["vehicleId"] = response.data.vehicleId[0]._id;

                })
                .catch((error) => {
                    this.loading = false;
                    console.error("tripDetails.getTransportTripDetails-error:", error);
                });
        },
        getCityId(cityId) {
            this.transportTrip.dumpYardId = '';
            this.transportTrip.segregationId = '';
            this.transportTrip.driverId = '';
            this.transportTrip.vehicleId = '';

            this.getVehicleList(cityId);
            this.getDriverList(cityId);
            this.getSegregationPlantList(cityId);
            this.getDumpYardList(cityId);
        },
    },
    created() {
        const promises = [];
        this.loading = true;
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getTrip());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
};
</script>

<style>
h4 {
    font-weight: bold;
}

.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
.paddi_driver h4{
    padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// createTransportPointTrip.vue?668d6eef